import { render, staticRenderFns } from "./item4.vue?vue&type=template&id=4af231f2&scoped=true"
import script from "./item4.vue?vue&type=script&lang=js"
export * from "./item4.vue?vue&type=script&lang=js"
import style0 from "./item4.vue?vue&type=style&index=0&id=4af231f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af231f2",
  null
  
)

export default component.exports